<template>
    <div class="totals-item">
        <p class="mb-0 heading-foot text-uppercase">Operating Cost Per Vehicle</p>
        <small><em>Estimated values based on per vehicle inputs</em></small>
        <div class="d-flex justify-content-between mt-4">

            <div class="mr-5" v-if="usage == 'miles'">
                <p class="mb-0" v-html="formatPrice( (fuelCost['cost-per-mile'] + equipmentCost['cost-per-mile'] + otherCost['cost-per-mile']) * currencyExchange)"></p>
                <small>Total Cost Per Mile</small>
            </div>
            <div class="mr-5" v-if="usage == 'hours'">
                <p class="mb-0" v-html="formatPrice( (fuelCost['cost-per-hour'] + equipmentCost['cost-per-mile'] + Number(otherCost['cost-per-hour'])) * currencyExchange)"></p>
                <small>Total Cost Per Hour</small>
            </div>

            <div>
                <p class="mb-0" v-if="usage == 'miles'" v-html="formatPrice( (fuelCost['annual-cost'] + equipmentCost['annual-cost'] + otherCost['annual-cost']) * currencyExchange, 0)"></p>
                <p class="mb-0" v-if="usage == 'hours'" v-html="formatPrice( (fuelCost['annual-cost-hourly'] + equipmentCost['annual-cost'] + otherCost['annual-cost-hourly']) * currencyExchange, 0)"></p>
                <small>Total Annual Cost</small>
            </div>

        </div>
    </div>

    <div class="totals-item">
        <p class="mb-0 summary-link">
            <a href="#" class="big-link heading-2 text-center text-white" data-toggle="modal" data-target="#summary-electric" @click="trackSummaryModal()">
                <img :src="`${imagePath}/summary-icon.png`" alt="" class="img-fluid"> View Full Summary
            </a>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'ElectricFooter',
        props: {
            fuelCost: {},
            equipmentCost: {},
            otherCost: {},
            usage: String
        },
        data() {
            return {
                currencyType: '',
                currencyExchange: 0,
                currentVehicle: {},
                imagePath: process.env.VUE_APP_ASSET_LOCATION
            }
        },
        mounted() {
            this.currenctVehicle = JSON.parse(localStorage.getItem('calculatorVehicleElectric'))
            this.currencyType = sessionStorage.getItem('currency')
            this.currencyExchange = this.currencyType == 'canada' ? Number(localStorage.getItem('USDtoCAD')) : 1
        },
        methods: {
            formatPrice(value, spaces = 2) {
                let val = (value/1).toFixed(spaces)
                return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            trackSummaryModal() {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - View Full Summary',
                    'event_label': this.$route.path
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .summary-link {
        text-transform: uppercase;
        font-size: 22px;
        color: #fff;
    }
</style>